import { Controller } from "@hotwired/stimulus"

/**
 * Variant Selector Controller
 * Handles variant selection for product pages with multiple variants (sizes, etc.)
 */
export default class extends Controller {
  static targets = ["form", "variantInput", "submitButton", "stockInfo"]
  static values = {
    addPath: String
  }

  connect() {
    // Check if a variant is pre-selected
    const checkedInput = this.element.querySelector('input[name="variant_id"]:checked')
    if (checkedInput) {
      this.updateUI(checkedInput)
    }
  }

  /**
   * Handle variant selection
   */
  select(event) {
    const input = event.target
    this.updateUI(input)
  }

  /**
   * Update UI based on selected variant
   */
  updateUI(input) {
    const variantId = input.value
    const stock = parseInt(input.dataset.stock, 10) || 0

    // Update hidden input
    if (this.hasVariantInputTarget) {
      this.variantInputTarget.value = variantId
    }

    // Enable/disable submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = stock <= 0
    }

    // Update stock info
    if (this.hasStockInfoTarget) {
      if (stock > 0) {
        this.stockInfoTarget.textContent = this.formatStockMessage(stock)
        this.stockInfoTarget.classList.remove("text-red-500")
        this.stockInfoTarget.classList.add("text-midgray")
      } else {
        this.stockInfoTarget.textContent = this.outOfStockMessage()
        this.stockInfoTarget.classList.remove("text-midgray")
        this.stockInfoTarget.classList.add("text-red-500")
      }
    }
  }

  formatStockMessage(count) {
    // Simple pluralization
    if (count === 1) {
      return `${count} en stock`
    }
    return `${count} en stock`
  }

  outOfStockMessage() {
    return "Rupture de stock"
  }
}
